import sortByStartDates from "../sort-by-start-dates";

export default function getFuturePeriod(items) {
  // Ensure chronologically ascending sort order.
  sortByStartDates(items);

  const now = new Date();
  return items.reduce((acc, cur) => {
    // Keep only future items.
    if (new Date(cur.startDate) <= now) {
      return acc;
    }

    // Keep only the closest future item.
    if (acc) {
      return acc;
    }

    // -> Replace acc (null) by cur as soon as the condition matches.
    //    Do not change acc after its first assignment.
    return cur;
  }, null);
}
